import { render, staticRenderFns } from "./2_SecteurEffectif.vue?vue&type=template&id=824df0a8&scoped=true&"
import script from "./2_SecteurEffectif.vue?vue&type=script&lang=js&"
export * from "./2_SecteurEffectif.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "824df0a8",
  null
  
)

export default component.exports